export default __webpack_public_path__ + "staticlp1/media/titulo-mais-recente-1.265a2c48.png";